module.exports = __webpack_public_path__ + "img/picto-operateur-plus.510f8625.svg";